<template>
  <div ref="wrapper" :class="isFull ? 'wrapper-full' : 'wrapper'">
    <div ref="container" :class="'container'"></div>
    <div class="bottom">
      <div class="tool">
        <img
          v-if="isPause"
          class="icon unpause"
          @click="changePause"
          src="@/assets/img/video/zt1.svg"
        />
        <img
          v-else
          class="icon pause"
          @click="changePause"
          src="@/assets/img/video/zt.svg"
        />
        <div class="time">{{ curMinute }}</div>
        <el-slider
          v-if="isFull"
          class="progress"
          v-model="progressValue"
          :min="maxProgressValue"
          :max="0"
          @change="progressChange"
          :vertical="true"
          :show-tooltip="false"
        />
        <el-slider
          v-else
          class="progress"
          v-model="progressValue"
          :min="0"
          :max="maxProgressValue"
          @change="progressChange"
          :show-tooltip="false"
        />
        <div class="time">{{ maxMinute }}</div>
        <img
          v-if="isFull"
          class="icon full"
          @click="changeFull"
          src="@/assets/img/video/exit_full_screen.svg"
        />
        <img
          v-else
          class="icon full"
          @click="changeFull"
          src="@/assets/img/video/full_screen.svg"
        />
      </div>
    </div>
    <div class="thoroughfare">
      <div
        class="thoroughfare-item"
        :class="curThoroughfare === item.superDevChannel && 'actived'"
        v-for="(item, index) in thoroughfares"
        :key="index"
        @click="changeThoroughfare(item)"
      >
        通道{{ item.superDevChannel }}
        <div
          class="status"
          :style="{ background: statusColorMap[item.status] }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import EzuikitFlv from "ezuikit-flv";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

export default {
  data() {
    return {
      ysToken: this.$route.query.ysToken || "at.05036pfc1todgfcv0yj51aja1hw4c570-8z6qioxcic-1vr2vut-w84scmaos", //萤石云token
      cloudseeToken: this.$route.query.cloudseeToken, //慧视云token

      player: null,
      progressTimer: null,
      progressValue: 0,
      maxProgressValue: 100,
      maxMinute: "00:00",
      startTime: "2025-04-23 00:05:00",
      endTime: "2025-04-23 00:10:00",
      recordUrl: null,
      isPause: false, // 是否暂停
      isFull: false, // 是否全屏
      thoroughfares: [], //通道列表
      curThoroughfare: 1,
      statusColorMap: {
        1: "#67C23A",
        0: "#909399",
        2: "#F7BA2A",
      },
    };
  },
  computed: {
    curMinute() {
      return dayjs.duration(this.progressValue, "seconds").format("mm:ss");
    },
  },
  created() {
    dayjs.extend(duration);
  },
  async mounted() {
    console.log(111, this.wxToken);
    this.getThoroughfare();

    this.recordUrl = await this.getRecordUrl();
    this.videoPlay(this.recordUrl);
    const time1 = dayjs(this.startTime);
    const time2 = dayjs(this.endTime);
    this.maxProgressValue = time2.diff(time1, "second");
    this.maxMinute = dayjs
      .duration(this.maxProgressValue, "seconds")
      .format("mm:ss");
  },
  beforeDestroy() {
    this.player && this.player.destroy();
    this.progressTimer && clearInterval(this.progressTimer);
  },
  methods: {
    // 萤石云获取回放链接
    async getRecordUrl(startTime = null) {
      const params = {
        deviceSerial: "FX1933141",
        channelNo: this.curThoroughfare,
        protocol: 4,
        type: 2,
        startTime: startTime || this.startTime,
        stopTime: this.endTime,
      };
      const newParams = new URLSearchParams();
      // 遍历对象并添加到 URLSearchParams
      Object.entries(params).forEach(([key, value]) => {
        newParams.append(key, value);
      });
      const { data } = await this.$axios({
        method: "post",
        url: "https://open.ys7.com/api/lapp/v2/live/address/get",
        data: newParams,
        headers: {
          accessToken: this.ysToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      return data.data ? data.data.url : null;
    },
    // 萤石云 视频播放
    videoPlay(recordUrl) {
      if(!recordUrl){
        return;
      }
      this.player && this.player.destroy();
      this.progressTimer && clearInterval(this.progressTimer);

      this.player = new EzuikitFlv({
        container: this.$refs.container,
        // debug: true,
        url: recordUrl,
        hasAudio: true,
        loadingTimeoutReplay: true,
        decoder: "decoder.js", // 软解解码资源 （wasm 要和js 在同一个文件夹中）
      });

      this.player.play();
      this.isFull && this.player.setRotate(90);

      setTimeout(() => {
        this.isPause && this.player.pause();
      }, 1000);

      this.progressTimer = setInterval(() => {
        const playState = this.player.getState();
        if (playState.playing) {
          this.progressValue = this.isFull ? this.progressValue - 1 : this.progressValue + 1;
        }
      }, 1000);
    },
    // 改变进度条
    async progressChange() {
      const specifiedTime = dayjs(this.startTime);
      const newTime = specifiedTime
        .add(this.progressValue, "second")
        .format("YYYY-MM-DD HH:mm:ss");
      this.videoPlay(await this.getRecordUrl(newTime));
    },
    // 是否暂停
    changePause() {
      this.isPause = !this.isPause;
      if (this.isPause) {
        this.player.pause();
      } else {
        this.player.play();
      }
    },
    // 是否全屏
    changeFull() {
      this.isFull = !this.isFull;
      const el = this.$refs.wrapper;
      this.$nextTick(() => {
        if (this.isFull) {
          this.player.setRotate(90);
          this.player.resize();
          el;
        } else {
          this.player.setRotate(0);
          this.player.resize();
        }
      });
    },
    // 获取通道
    async getThoroughfare() {
      const { data } = await this.$axios({
        method: "get",
        url: "https://open.ys7.com/api/v3/open/device/metadata/channel/status",
        headers: {
          accessToken: this.ysToken,
          deviceSerial: "FX1933141",
        },
      });
      this.thoroughfares = data.result.data.channelInfoList;
      console.log(2222, data);
    },
    // 选择通道
    async changeThoroughfare(item) {
      if (this.curThoroughfare !== item.superDevChannel) {
        this.curThoroughfare = item.superDevChannel;
        this.videoPlay(await this.getRecordUrl());
        this.progressValue = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: calc(56.3vw + 4rem) !important;
  background: #000;
  position: relative;
}

.bottom {
  width: 100vw;
  position: absolute;
  transform: translateY(-100%);
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0) 100%
  );

  .progress {
    width: 100%;
    height: 40px;
    padding: 0;
    margin: 0;
    background: transparent;
    border-radius: 0;
    overflow: visible;
  }

  .time {
    color: #fff;
    padding: 0 10px;
  }

  .tool {
    padding: 10px;
    // background: #000;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon {
      width: 30px;
      height: 30px;
      padding: 5px;
    }
  }
}

.wrapper{
  position: absolute;
  width: 100%;
}

// 全屏样式
.wrapper-full {
  position: fixed;
  width: 100vw;
  .container {
    position: relative;
    height: 100vh !important;
  }
  .bottom {
    position: absolute;

    width: 60px;
    height: 100vh;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    .tool {
      flex-direction: column;
      height: 100%;
      position: relative;
    }
    /deep/.progress {
      height: 100%;
      .el-slider__runway {
        background-color: #409eff;
      }
      .el-slider__bar {
        background-color: #e4e7ed;
      }
    }
    .icon {
      transform: rotate(90deg);
    }
    .time {
      padding: 20px;
      transform: rotate(90deg);
    }
    // width: 100vh;
    // transform: translate(-50%, -100%) rotate(90deg);
    // top: 50%;
    // left: 30px;
  }
}

.thoroughfare {
  display: flex;
  margin: 1.25rem;
  &-item {
    padding: 1rem 1rem;
    font-size: 1.125rem;
    border: 0.125rem solid #7b7b7b;
    color: #7b7b7b;
    margin-right: 1.25rem;
    border-radius: 0.3125rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .actived {
    border: 0.125rem solid rgb(47, 116, 254);
    color: rgb(47, 116, 254);
  }
  .status {
    border-radius: 50%;
    background: #000;
    width: 0.75rem;
    height: 0.75rem;
    margin-left: 0.625rem;
  }
}
</style>
